import type { KeyValue, PsetGroup } from '@viewer/lib/ifcItemData'

export interface FilterableView {
  attributes: KeyValue[]
  psets: PsetGroup[]
  qsets: PsetGroup[]
}

/** Filtra atributos, psets e qsets por um termo (substring, case-
 *  insensitive) sobre o nome do set, o nome da propriedade e o valor.
 *  Um set cujo NOME bate mostra todas as linhas; senão só as linhas que
 *  batem, e o set some se nenhuma bater. Termo vazio devolve a mesma
 *  vista (mesmas referências, sem custo). */
export function filterProps(
  view: FilterableView,
  rawTerm: string,
): FilterableView {
  const term = rawTerm.trim().toLowerCase()
  if (!term) return view
  const rowHit = (r: KeyValue) =>
    r.key.toLowerCase().includes(term) ||
    (r.value ?? '').toLowerCase().includes(term)
  const filterGroups = (groups: PsetGroup[]): PsetGroup[] => {
    const out: PsetGroup[] = []
    for (const g of groups) {
      if (g.name.toLowerCase().includes(term)) out.push(g)
      else {
        const rows = g.rows.filter(rowHit)
        if (rows.length > 0) out.push({ ...g, rows })
      }
    }
    return out
  }
  return {
    attributes: view.attributes.filter(rowHit),
    psets: filterGroups(view.psets),
    qsets: filterGroups(view.qsets),
  }
}
